import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@core/core.module';
import { SpinnerInterceptor } from '@core/interceptors/spinner.interceptor';
import { ComponentsModule } from 'src/app/components/components.module';
import { MaterialModule } from 'src/app/material.module';
import { PrimeNgModule } from 'src/app/primeng.module';
import { InvoicesRoutingModule } from './invoices-routing.module';
import { ListInvoicesComponent } from './pages/list-invoices/list-invoices.component';

@NgModule({
  declarations: [ListInvoicesComponent],
  imports: [
    CommonModule,
    InvoicesRoutingModule,
    FormsModule,
    MaterialModule,
    HttpClientModule,
    ReactiveFormsModule,
    CoreModule,
    PrimeNgModule,
    ComponentsModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
  ],
})
export class InvoicesModule {}
